module.exports = __webpack_public_path__ + "img/gangweiwaibao.7389d190.png";